import React, { useState } from "react";
import swal from "sweetalert";
import { useSet, useDetail } from "seed/gql";
import { usePost } from "seed/api";
import { USER, SET_USER } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/vmisc/onboarding/Onboarding.view";


function Onboarding() {

  const userId = sessionStorage.getItem('id');
  const [step, setStep] = useState(1);
  const profiles = [
    {
      id: "rrhh", name: l("RRHH%VE001"), icon: "fas fa-users", color: "#5b9bd5"
    },
    {
      id: "purchasing", name: l("Compras%VE003"), icon: "fas fa-file-invoice", color: "#92d050"
    },
    {
      id: "sales", name: l("Ventas%VE002"), icon: "fas fa-handshake", color: "#ffc000"
    },
    {
      id: "legal", name: "Legal", icon: "fas fa-balance-scale", color: "#bd92de"
    },
    {
      id: "ti", name: l("TI%VE004"), icon: "fas fa-laptop-code", color: "#b30000"
    },
    {
      id: "other", name: l("Otro%VE005"), icon: "fas fa-plus-circle", color: "#708090"
    }
  ];

  const reqUser = useDetail(USER, userId);

  const [callSetPersonalInformation, reqSetPersonalInformation] = usePost("/users/set-personal-information", {
    onCompleted: () => {
      setStep(2);
    },
    onError: () => {
      swal("Ha ocurrido un error");
    }
  });

  const [callSet, setCallSet] = useSet(SET_USER, {
    onCompleted: () => {
      window.location.reload();
    },
    onError: () => {
      alert(l("Ha ocurrido un error%GA019"));
    }
  });

  const onClickNextStep = () => {
    setStep(step + 1);
  }

  const onClickBackStep = () => {
    setStep(step - 1);
  }

  const onSubmit = (values) => {
    // callSet({
    //   id: userId,
    //   accountSettings: {
    //     ...user.accountSettings,
    //     theme: {
    //       primaryColor: values?.primaryColor,
    //       accentColor: values?.accentColor
    //     },
    //     is_onboarding_finished: true
    //   }
    // });

    if (step == 1) {
      callSetPersonalInformation({
        user_id: userId,
        first_name: values.firstName,
        last_name: values.lastName,
        password: values.password
      });
    }

  }

  const onClickSkipOnboarding = () => {
    callSet({
      id: userId,
      accountSettings: {
        ...user.accountSettings,
        is_onboarding_finished: true,
      }
    });
  }

  if (reqUser.loading) return <Loading />;
  if (reqUser.error) return "Error";

  const { user = {} } = reqUser.data;

  return (
    <View
      user={user}
      step={step}
      profiles={profiles}
      onClickNextStep={onClickNextStep}
      onClickBackStep={onClickBackStep}
      onClickSkipOnboarding={onClickSkipOnboarding}
      onSubmit={onSubmit}
    />
  );
}

Onboarding.propTypes = {};

export default Onboarding;